<template>
  <section>
    <gs-header :title="`Chi tiết phiếu thu: <span class='shipment-code-display click-copy'>${receipt.id}</span>`"
      :breadcrumbs="[
        { title: 'Quản lý phiếu thu', route: { name: 'receipt' } }
      ]">
      <el-popover ref="confirmPopup" placement="top" width="200" v-model="confirmPopup">
        <p>Bạn chắc chắn muốn xác nhận phiếu thu này?</p>
        <div style="text-align: right; margin: 0">
          <button class="ui red mini basic button" @click="confirmPopup = false">Không</button>
          <button class="ui green mini basic button" :disabled="!confirmPopup" @click.prevent="confirmReceipt">Xác
            nhận</button>
        </div>
      </el-popover>
      <a v-if="receipt.client_id && receipt.confirmer_id" class="ui mini violet button" @click.prevent="returnHandler">Cần
        truy thu</a>
      <a v-if="receipt.client_id && receipt.confirmer_id" class="ui mini violet button"
        @click.prevent="returnedHandler">Đã truy thu</a>
      <a v-popover:confirmPopup v-show="!receipt.confirmer_id" class="ui mini green button"><i class="fa fa-check"></i>
        Xác nhận</a>
    </gs-header>
    <div class="padding-sm-all margin-top padding-lg-bottom" v-if="receipt.id">
      <el-row :gutter="20" class="remove-margin">
        <el-col :span="12" class="border-right">
          <h3 class="text-center">Người tạo</h3>
          <p>Họ tên: {{ receipt.creator.data.name }}</p>
          <p>Tên đăng nhập: {{ receipt.creator.data.email }}</p>
          <p>Ngày tạo: {{ receipt.created_at }}</p>
        </el-col>
        <el-col :span="12" class="border-right">
          <h3 class="text-center">Xác nhận</h3>
          <p>Họ tên: {{ receipt.confirmer.data.name }}</p>
          <p>Tên đăng nhập: {{ receipt.confirmer.data.email }}</p>
          <p>Ngày tạo: {{ receipt.confirmed_at }}</p>
        </el-col>
        <el-row :gutter="20" v-if="receipt.client_id">
          <el-col :span="24" class="padding-lg-left padding-lg-all">
            Khách hàng: {{ receipt.client.data.name }} | {{ receipt.client.data.email }}
          </el-col>
        </el-row>
        <el-col :span="24" class="padding-lg-all bg-grey margin-top text-white">
          Lý do: {{ receipt.description }}
        </el-col>
      </el-row>
      <el-row class="remove-margin margin-top">
        <el-col :span="24">
          <h3 class="text-center">Danh sách vận đơn</h3>
          <el-table :data="receipt.shipments.data" border style="width: 100%">

            <el-table-column type="index" width="40">
            </el-table-column>

            <el-table-column label="Mã đơn" width="120">
              <template slot-scope="scope">
                <p>
                  <el-tooltip placement="top" content="Mã đơn" class="display-inline">
                    <span class="shipment-code-display click-copy">{{ scope.row.id }}</span>
                  </el-tooltip>
                </p>
                <p>
                  <el-tooltip placement="top" content="Mã đơn HVC" class="display-inline">
                    <span class="shipment-code-display click-copy">{{ scope.row.code }}</span>
                  </el-tooltip>
                </p>
              </template>
            </el-table-column>

            <el-table-column label="COD">
              <template slot-scope="scope">
                <span class="text-red click-copy">{{ scope.row.amount_for_cross | vnd }}</span>
              </template>
            </el-table-column>

            <el-table-column label="Người trả phí" width="105">
              <template slot-scope="scope">
                {{ scope.row.payer_txt }}
              </template>
            </el-table-column>

            <el-table-column label="Phí vận chuyển">
              <template slot-scope="scope">
                <span class="text-red click-copy">{{ scope.row.total_fee | vnd }}</span>
              </template>
            </el-table-column>

            <el-table-column label="Phí khác">
              <template slot-scope="scope">
                <p>Chuyển hoàn: <span class="text-red click-copy">{{ scope.row.return_fee | vnd }}</span></p>
                <p>Vượt cân: <span class="text-red click-copy">{{ scope.row.overweight_fee | vnd }}</span></p>
              </template>
            </el-table-column>

            <el-table-column label="Cân nặng">
              <template slot-scope="scope">
                <p>Cân nặng: <span class="text-orange click-copy">{{ scope.row.parcel.data.weight | gam }}</span></p>
                <p>Cân thực tế: <span class="text-orange click-copy">{{ scope.row.parcel.data.real_weight | gam }}</span>
                </p>

              </template>
            </el-table-column>

            <el-table-column label="Trạng thái" width="100">
              <template slot-scope="scope">
                <span :class="shipmentStatuses[scope.row.status]">{{ scope.row.status_txt }}</span>
              </template>
            </el-table-column>

            <el-table-column label="Tổng tiền trả shop">
              <template slot-scope="scope">
                <span class="text-red click-copy">{{ scope.row.amount_return_shop | vnd }}</span>
              </template>
            </el-table-column>

          </el-table>
        </el-col>
      </el-row>
      <el-row class="remove-margin margin-top" :gutter="20">
        <el-col :span="12" :offset="12" class="padding-lg-right">
          <h3>&nbsp;</h3>
          <p><span class="text-bold">Tổng tiền <sup>(1)</sup>:</span> <span
              class="pull-right text-red click-copy">{{ receipt.amount | vnd }}</span></p>
          <p v-if="receipt.money_return"><span class="text-bold">Tiền nợ <sup>(2)</sup>:</span> <span
              class="pull-right text-red click-copy">{{ receipt.money_return | vnd }}</span></p>
          <p v-if="receipt.money_return"><span class="text-bold">Tổng tiền thực trả <sup>(1) - (2)</sup>:</span> <span
              class="pull-right text-red click-copy">{{ receipt.real_amount | vnd }}</span></p>
        </el-col>
      </el-row>
    </div>
    <el-dialog title="Cần truy thu công nợ" :visible.sync="dialogReturner">
      <el-table :data="listReturn" border>
        <el-table-column label="Mã">
          <template slot-scope="scope">
            <a href="#" @click.prevent="detailInvoiceBlankTab(scope.row.id)" target="_blank">
              <span class="shipment-code-display click-copy">{{ scope.row.id }}</span>
            </a>
          </template>
        </el-table-column>
        <el-table-column label="Số nợ">
          <template slot-scope="scope">
            <span class="text-red click-copy">{{ scope.row.real_amount | number }}</span>
          </template>
        </el-table-column>
        <el-table-column label="" width="120">
          <template slot-scope="scope">
            <button type="button" :disabled="pendingReturn" class="ui mini violet button"
              @click="returnInvoice(scope.row)">Truy thu</button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog title="Đã truy thu công nợ" :visible.sync="dialogReturned">
      <el-table v-if="receipt.returns" :data="receipt.returns.data" border>
        <el-table-column label="Mã" width="100">
          <template slot-scope="scope">
            <a href="#" @click.prevent="detailInvoiceBlankTab(scope.row.invoice_id)" target="_blank">
              <span class="shipment-code-display click-copy">{{ scope.row.invoice_id }}</span>
            </a>
          </template>
        </el-table-column>
        <el-table-column label="Số tiền đã thu">
          <template slot-scope="scope">
            <span class="text-red click-copy">{{ scope.row.total_amount | number }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Người truy thu">
          <template slot-scope="scope">
            <span class="text-red" v-if="scope.row.returner">{{ scope.row.returner.data.name }} |
              {{ scope.row.returner.data.email }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { shipmentStatuses } from 'src/stubs/shipments'
import { confirmReceipt } from 'src/api/receipt'
import { getAllInvoice, returnInvoice } from 'src/api/invoice'
export default {
  name: 'DetailReceipt',
  data() {
    return {
      confirmPopup: false,
      payPopup: false,
      shipmentStatuses: shipmentStatuses,
      dialogReturner: false,
      dialogReturned: false,
      listReturn: [],
      pendingReturn: false
    }
  },
  methods: {
    ...mapActions('receipt', ['getReceiptDetail']),
    confirmReceipt() {
      this.confirmPopup = false
      confirmReceipt(this.receipt.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Xác nhận phiếu thu thành công'
          })
          this.getReceiptDetail({ id: this.$route.params.id, params: { include: 'shipments,creator,client,confirmer,payer,client.banks,shipments.parcel' } })
        } else {
          this.$message({
            type: 'error',
            message: 'Xác nhận phiếu thu thất bại'
          })
        }
      })
    },
    returnHandler() {
      this.dialogReturner = true
      this.getListReturnInvoices()
    },
    getListReturnInvoices() {
      getAllInvoice({ client_id: this.receipt.client.data.id, is_debt: 1, limit: -1 }).then(response => {
        if (response.code === 200) {
          this.listReturn = response.data
        } else {
          this.listReturn = []
        }
      })
    },
    returnedHandler() {
      this.dialogReturned = true
    },
    returnInvoice(invoice) {
      this.pendingReturn = true
      this.returnPopup = false
      let dataReturn = {
        type: 1, // truy thu bằng phiếu thu
        relation_id: this.receipt.id
      }
      returnInvoice(invoice.id, dataReturn).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Truy thu công nợ phiếu chi thành công'
          })
          this.getReceiptDetail({ id: this.$route.params.id, params: { include: 'shipments,creator,client,confirmer,payer,client.banks,shipments.parcel,returns.returner' } })
          this.getListReturnInvoices()
          this.pendingReturn = false
        } else {
          this.$message({
            type: 'error',
            message: 'Truy thu công nợ phiếu chi thất bại'
          })
          this.pendingReturn = false
        }
      })
    },
    detailInvoiceBlankTab(id) {
      window.open('/invoice/' + id)
    }
  },
  computed: {
    ...mapGetters('receipt', ['receipt'])
  },
  mounted() {
    this.getReceiptDetail({ id: this.$route.params.id, params: { include: 'shipments,creator,client,confirmer,payer,client.banks,shipments.parcel,returns.returner' } })
  }
}
</script>

<style lang="css" scoped>
.border-right {
  border-right: 1px solid #dfe6ec;
}
</style>



// WEBPACK FOOTER //
// DetailReceipt.vue?13b3d31a